import { Header } from "../components/landing/Header";
import { HeroSection } from "../components/landing/HeroSection";
import { ProblemSection, SolutionSection } from "../components/landing/ProblemSolutionSection";
import { FeaturesSection } from "../components/landing/FeaturesSection";
import { HowItWorksSection } from "../components/landing/HowItWorksSection";
import { ImagineSection, IndustriesSection, WhiteLabelSection } from "../components/landing/BottomSections";
import { FAQSection } from "../components/landing/FAQSection";
import { CTASection, Footer } from "../components/landing/CTAFooter";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <FeaturesSection />
      <HowItWorksSection />
      <ImagineSection />
      <IndustriesSection />
      <WhiteLabelSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
